import React, { useEffect, useState } from "react";
import { Container, Services } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import {
  InputC,
  ButtonC,
  InputNumberC,
  InputTel,
} from "../../../components/simple";
import ModalC from "../../../components/modal";
import { useAuth } from "../../../hooks/AuthContext";
import { MdAdd, MdRemove } from "react-icons/md";
import { InputLabelMUI } from "../../../components/simple/styles";
import { useQuery } from "../../../hooks/Location";
import { Button, Input, Modal, Select, Spin } from "antd";
import { Message, ViewInput } from "../../../GlobalStyles";
import { getValue } from "../../../services/functions";

export default function NewContract() {
  const { user } = useAuth();

  const query = useQuery();

  const navigate = useNavigate();

  const [nameService, setNameService] = useState("");
  const [valueService, setValueService] = useState(0);
  const [amountService, setAmountService] = useState(0);
  const [descriptionService, setDescriptionService] = useState("");

  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [servicesContract, setServicesContract] = useState([]);
  const [servicesObj, setServicesObj] = useState({});
  const [name, setName] = useState("");
  const [nameModal, setNameModal] = useState("");
  const [company, setCompany] = useState("");
  const [leadId, setLeadId] = useState("");
  const [consultant, setConsultant] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [contact, setContact] = useState("");
  const [banking, setBanking] = useState(
    "FORMA DE PAGAMENTO: Á VISTA\n\nPRAZO DE ENTREGA: EM ATÉ 24 HORAS"
  );
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalService, setVisibleModalService] = useState(false);
  const [nameExtra, setNameExtra] = useState("");
  const [descriptionExtra, setDescriptionExtra] = useState("");
  const [valueExtra, setValueExtra] = useState(0);
  const [risco, setRisco] = useState(0);
  const [vidas, setVidas] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [value, setValue] = useState(0);
  const [valueToLife, setValueToLife] = useState(0);
  const [initialValue, setInitialValue] = useState(0);
  const [description, setDescription] = useState("");
  const [descriptionGM, setDescriptionGM] = useState("");
  const [visibleModalServiceGM, setVisibleModalServiceGM] = useState(false);

  useEffect(() => {
    if (user.type == "tecnico") {
      navigate(-1);
    } else {
      if (user.course_restricted) {
        toast.warn("Área restrita para franqueados");
        navigate(-1);
      } else {
        loadingServices();
      }
    }
  }, []);

  function totalValue() {
    let value = 0;
    servicesContract.map((item) => {
      value += item.amount * item.value;
    });
    return value;
  }

  function getValueToLife(vidas) {
    if (!vidas) {
      vidas = 0;
    }
    if (risco == 1 || risco == 2) {
      if (vidas <= 10) {
        setValueToLife(12);
      } else {
        if (vidas <= 20) {
          setValueToLife(11.88);
        } else {
        }
        if (vidas <= 30) {
          setValueToLife(11.76);
        } else {
          setValueToLife(11.64);
        }
      }
    } else {
      if (vidas <= 10) {
        setValueToLife(15);
      } else {
        if (vidas <= 20) {
          setValueToLife(14.85);
        } else {
        }
        if (vidas <= 30) {
          setValueToLife(14.7);
        } else {
          setValueToLife(14.55);
        }
      }
    }
  }

  async function loadingServices() {
    let leadId = query.get("lead");
    if (leadId) {
      setLeadId(leadId);
      await api.get(`/lead/${leadId}`).then((response) => {
        setCompany(response.data.name);
      });
    }
    await api
      .get(`/services-client`)
      .then((response) => {
        let servicesObj = {};
        response.data.services.map((item) => {
          servicesObj[item.name] = {
            name: item.name,
            description: item.description,
            value: item.value,
          };
        });
        setServicesObj(servicesObj);
        setServices(response.data.services);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createContract() {
    if (
      !name ||
      !company ||
      !contact ||
      !consultant ||
      !phone_number ||
      !banking
    ) {
      toast.warn("Preencha todos os campos básicos");
    } else {
      let items = [];
      servicesContract.map((item) => {
        if (item.amount > 0) {
          items.push(item);
        }
      });
      const isCrm = query.get("crm");
      await api
        .post(`/contract`, {
          name,
          company,
          contact,
          consultant,
          phone_number,
          banking,
          is_crm: isCrm == "true",
          lead_id: leadId,
          services_gestao: descriptionGM,
          services: items,
          risk: parseFloat(risco),
          lifes: parseFloat(vidas),
          initial_value: parseFloat(initialValue),
          life_value: parseFloat(valueToLife),
          discount: parseFloat(desconto),
          service_name: nameExtra,
          service_value: parseFloat(valueExtra),
          service_description: descriptionExtra,
        })
        .then(async (ok) => {
          toast.success("Contrato criada com sucesso");
          navigate(-1);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    }
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Container>
        {loading ? (
          <Spin size="large" style={{ marginTop: 50 }} />
        ) : (
          <>
            <h1>Novo Contrato</h1>

            <h2>Dados do contrato</h2>
            <ViewInput style={{ width: "48%" }}>
              <p>Nome da Empresa</p>
              <Input
                value={company}
                placeholder={"guruseg"}
                width={"100%"}
                height={"55px"}
                color="#999"
                onChange={(text) => {
                  setCompany(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Nome do Contato</p>
              <Input
                value={name}
                placeholder={"nome"}
                width={"100%"}
                height={"55px"}
                color="#999"
                onChange={(text) => {
                  setName(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Telefone do Contato</p>
              <Input
                value={contact}
                placeholder={"telefone"}
                width={"100%"}
                height={"55px"}
                color="#999"
                onChange={(text) => {
                  setContact(text.target.value);
                }}
              />
            </ViewInput>

            <ViewInput style={{ width: "48%" }}>
              <p>Consultor</p>
              <Input
                value={consultant}
                placeholder={"consultor"}
                width={"100%"}
                height={"55px"}
                color="#999"
                onChange={(text) => {
                  setConsultant(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Telefone</p>
              <Input
                value={phone_number}
                placeholder={"telefone"}
                width={"100%"}
                height={"55px"}
                color="#999"
                onChange={(text) => {
                  setPhone_number(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput>
              <p>Dados bancario</p>
              <Input.TextArea
                value={banking}
                placeholder={"dados bancarios"}
                style={{
                  minHeight: 80,
                }}
                color="#999"
                onChange={(text) => {
                  setBanking(text.target.value);
                }}
              />
            </ViewInput>

            <h2>Serviços de Elaboração e Gestão em segurança do Trabalho</h2>

            <ViewInput style={{ width: "48%" }}>
              <p>Grau de Risco</p>
              <Select
                style={{
                  width: "100%",
                  textAlign: "left",
                }}
                value={risco}
                onChange={(value) => {
                  setRisco(value);
                  getValueToLife(vidas);
                }}
              >
                <Select.Option value={0}>Seleciona uma opção</Select.Option>
                <Select.Option value={1}>Grau 1</Select.Option>
                <Select.Option value={2}>Grau 2</Select.Option>
                <Select.Option value={3}>Grau 3</Select.Option>
                <Select.Option value={4}>Grau 4</Select.Option>
              </Select>
            </ViewInput>
            {risco != 0 && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                <ViewInput style={{ width: "32%" }}>
                  <p>Valor por vida</p>
                  <Input
                    value={valueToLife}
                    placeholder={"valor"}
                    width={"100%"}
                    height={"55px"}
                    color="#999"
                    onChange={(text) => {
                      setValueToLife(text.target.value);
                    }}
                  />
                </ViewInput>
                <ViewInput style={{ width: "32%" }}>
                  <p>Vidas</p>
                  <Input
                    value={vidas || ""}
                    placeholder={"quantidade"}
                    width={"100%"}
                    height={"55px"}
                    color="#999"
                    onChange={(text) => {
                      setVidas(text.target.value);
                      getValueToLife(parseFloat(text.target.value));
                    }}
                  />
                </ViewInput>
                <ViewInput style={{ width: "32%" }}>
                  <p> Valor de Entrada</p>
                  <Input
                    value={initialValue || ""}
                    placeholder={"entrada"}
                    onChange={(text) => {
                      setInitialValue(text.target.value);
                    }}
                  />
                </ViewInput>
                {vidas > 0 && (
                  <div
                    style={{
                      width: "100%",
                      marginTop: 15,
                    }}
                  >
                    <h3>Valores</h3>
                    <h2 style={{ marginTop: 5 }}>
                      Entrada:{" "}
                      {(initialValue ? initialValue : 0).toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )}{" "}
                      - Mensal:{" "}
                      {(
                        57 +
                        (vidas ? vidas : 0) * (valueToLife ? valueToLife : 0)
                      ).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}{" "}
                      - Anual:{" "}
                      {(
                        (initialValue ? initialValue : 0) +
                        (57 +
                          (vidas ? vidas : 0) *
                            (valueToLife ? valueToLife : 0)) *
                          12
                      ).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </h2>
                  </div>
                )}

                <div
                  style={{
                    width: "100%",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "10px 0",
                  }}
                >
                  <h2
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Serviços Inclusos
                  </h2>
                  <Button
                    onClick={() => {
                      setVisibleModalServiceGM(true);
                    }}
                    type="primary"
                    style={{
                      borderRadius: 50,
                      fontSize: 15,
                      padding: "2px 12px 2px 8px",
                    }}
                  >
                    <MdAdd color="#fff" />
                    Adicionar
                  </Button>
                </div>
                <Input.TextArea
                  value={descriptionGM}
                  placeholder={"Descreva os serviços inclusos na Gestão Mensal"}
                  style={{ minHeight: 120 }}
                  onChange={(text) => {
                    setDescriptionGM(text.target.value);
                  }}
                />
              </div>
            )}

            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "10px 0",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h2
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 15,
                }}
              >
                Serviços Avulsos
              </h2>
              <Button
                onClick={() => {
                  setValueService(0);
                  setNameService("");
                  setAmountService(1);
                  setVisibleModalService(true);
                }}
                type="primary"
                style={{
                  borderRadius: 50,
                  fontSize: 15,
                  padding: "2px 12px 2px 8px",
                }}
              >
                <MdAdd color="#fff" />
                Adicionar
              </Button>
            </div>
            <Services>
              {servicesContract.length == 0 && (
                <Message
                  style={{
                    borderRadius: 5,
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 0,
                  }}
                >
                  Adicione algum serviço
                </Message>
              )}
              {servicesContract.map((item, index) => {
                return (
                  <div>
                    <div>
                      <Button
                        type="primary"
                        onClick={() => {
                          let servicesContractA = [...servicesContract];
                          servicesContractA[index].amount++;
                          setServicesContract(servicesContractA);
                        }}
                      >
                        <MdAdd color="#FFF" size={20} />
                      </Button>
                      <span>{item.amount}</span>
                      <Button
                        type="primary"
                        onClick={() => {
                          let servicesContractA = [...servicesContract];
                          if (servicesContractA[index].amount > 1) {
                            servicesContractA[index].amount--;
                            setServicesContract(servicesContractA);
                          } else {
                            setServicesContract(
                              servicesContractA.filter(
                                (data, idx) => idx != index
                              )
                            );
                          }
                        }}
                      >
                        <MdRemove color="#FFF" size={20} />
                      </Button>
                    </div>
                    <p style={{ flex: 1, minWidth: 100 }}>{item.name}</p>

                    {item.description && (
                      <Button
                        type="primary"
                        onClick={() => {
                          setDescription(item.description);
                          setName(item.name);
                          setValue(item.value);
                          setVisibleModal(true);
                        }}
                        style={{
                          marginLeft: 10,
                        }}
                      >
                        Detalhes
                      </Button>
                    )}
                    <p
                      style={{
                        flex: 1,
                        margin: "8px 0",
                        maxWidth: 85,
                        textAlign: "right",
                      }}
                    >
                      {item.value.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                  </div>
                );
              })}
            </Services>

            <ViewInput style={{ width: "48%" }}>
              <p>Serviço Extra</p>
              <Input
                value={nameExtra}
                placeholder={"nome"}
                onChange={(text) => {
                  setNameExtra(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Valor Extra</p>
              <Input
                value={valueExtra || ""}
                placeholder={"entrada"}
                onChange={(text) => {
                  setValueExtra(parseFloat(text.target.value) || "");
                }}
              />
            </ViewInput>
            <ViewInput>
              <p>Descrição do Serviço Extra</p>
              <Input.TextArea
                style={{
                  minHeight: 80,
                }}
                value={descriptionExtra}
                placeholder={"descrição"}
                onChange={(text) => {
                  setDescriptionExtra(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%", marginTop: 25 }}>
              <p>Desconto</p>
              <Input
                value={desconto || ""}
                placeholder={"desconto"}
                onChange={(text) => {
                  setDesconto(parseFloat(text.target.value) || "");
                }}
              />
            </ViewInput>
            <div
              style={{
                maxWidth: "48%",
                alignItems: "flex-end",
                marginTop: 25,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div class="total">
                <h4>
                  Total:{" "}
                  {getValue(
                    totalValue() + parseFloat(valueExtra ? valueExtra : 0)
                  )}
                </h4>
              </div>
              <div class="total" style={{ marginTop: 15 }}>
                <h4>
                  Total com Desconto:{" "}
                  {getValue(
                    totalValue() +
                      parseFloat(valueExtra ? valueExtra : 0) -
                      parseFloat(desconto ? desconto : 0)
                  )}
                </h4>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  margin: "35px 0",
                }}
              >
                <Button
                  style={{
                    borderRadius: 50,
                    marginRight: 15,
                    minWidth: 100,
                  }}
                  className="warning-button"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Voltar
                </Button>
                <Button
                  style={{
                    borderRadius: 50,
                    minWidth: 150,
                  }}
                  type="primary"
                  onClick={() => {
                    createContract();
                  }}
                >
                  Salvar
                </Button>
              </div>
            </div>
          </>
        )}
      </Container>
      <Modal
        open={visibleModal}
        onCancel={() => {
          setVisibleModal(false);
        }}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        cancelText="FECHAR"
      >
        <div
          style={{
            margin: "30px 0 20px 0",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 style={{ textAlign: "center", color: "#000" }}>{name}</h2>
          <p
            style={{
              textAlign: "center",
              color: "#000",
              margin: "15px 0",
              fontSize: 16,
            }}
          >
            {description}
          </p>
          <h3 style={{ textAlign: "center", color: "#000" }}>
            {value.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </h3>
        </div>
      </Modal>
      <ModalC
        visible={visibleModalService}
        executar={() => {
          setVisibleModalService(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <InputLabelMUI>Nome do serviço</InputLabelMUI>
          <input
            value={nameService}
            placeholder={"serviço"}
            list="services"
            style={{
              width: "100%",
              background: "#FFF",
              borderRadius: 5,
              height: 45,
              fontSize: 16,
              borderWidth: 1,
              borderColor: "#a2a2a2",
              borderStyle: "solid",
              borderRadius: 5,
              fontWeight: "400",
              paddingLeft: 12,
            }}
            onChange={(text) => {
              setNameService(text.target.value);
              if (servicesObj[text.target.value]) {
                setValueService(servicesObj[text.target.value].value * 3);
                setDescriptionService(
                  servicesObj[text.target.value].description
                );
              }
            }}
          />
          <datalist id="services">
            {services.map((item) => {
              return (
                <option value={item.name}>
                  {item.name} - {item.value} (valor sugerido de {item.value * 3}
                  )
                </option>
              );
            })}
          </datalist>
          <InputNumberC
            text={valueService}
            title={"Valor"}
            placeholder={"0,00"}
            width={"100%"}
            height={"55px"}
            executar={(text) => {
              setValueService(text);
            }}
          />
          <InputC
            text={amountService}
            type="number"
            title={"Quantidade"}
            placeholder={"0"}
            width={"100%"}
            height={"55px"}
            executar={(text) => {
              setAmountService(text);
            }}
          />
          <InputC
            text={descriptionService}
            title={"Descrição"}
            placeholder={"Descrição detalhada sobre o Serviço"}
            width={"100%"}
            height={120}
            multiline={true}
            executar={(text) => {
              setDescriptionService(text);
            }}
          />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "center",
              marginTop: 15,
            }}
          >
            <ButtonC
              text={""}
              title={"Adicionar"}
              width={"60%"}
              executar={() => {
                if (!nameService || !valueService || !amountService) {
                  toast.warning("Preencha nome, quantidade e valor");
                } else {
                  let servicesC = [...servicesContract];
                  servicesC.push({
                    name: nameService,
                    description: descriptionService,
                    value: valueService,
                    amount: amountService,
                  });
                  setServicesContract(servicesC);
                  setNameService("");
                  setDescriptionService("");
                  setValueService(0);
                  setAmountService(0);
                  toast.success("Serviço adicionado com sucesso");
                }
              }}
            />
          </div>
        </div>
      </ModalC>
      <ModalC
        visible={visibleModalServiceGM}
        executar={() => {
          setVisibleModalServiceGM(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <InputLabelMUI
            style={{
              width: "100%",
            }}
          >
            Nome do serviço
          </InputLabelMUI>
          <input
            value={nameService}
            placeholder={"serviço"}
            list="services"
            style={{
              flex: 1,
              background: "#FFF",
              borderRadius: 5,
              height: 45,
              fontSize: 16,
              borderWidth: 1,
              borderColor: "#c2c2c2",
              borderStyle: "solid",
              borderRadius: 5,
              fontWeight: "400",
              paddingLeft: 12,
            }}
            onChange={(text) => {
              setNameService(text.target.value);
            }}
          />
          <datalist id="services">
            {services.map((item) => {
              return <option>{item.name}</option>;
            })}
          </datalist>
          <button
            onClick={() => {
              if (servicesObj[nameService]) {
                setDescriptionGM(
                  (prev) => prev + "- " + servicesObj[nameService].name + "\n"
                );
              } else {
                setDescriptionGM((prev) => prev + "- " + nameService + "\n");
              }
              setNameService("");
            }}
            style={{
              width: 45,
              height: 45,
              marginLeft: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f2760a",
              borderRadius: 6,
            }}
          >
            <MdAdd color="#fff" size={24} />
          </button>
          <InputC
            text={descriptionGM}
            type="text"
            title={""}
            placeholder={"Descreva os serviços inclusos na Gestão Mensal"}
            width={"100%"}
            multiline
            minHeight={"150px"}
            height={"55px"}
            color="#999"
            style={{ textAlign: "left" }}
            executar={(text) => {
              setDescriptionGM(text);
            }}
          />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "center",
              marginTop: 15,
            }}
          >
            <ButtonC
              text={""}
              title={"Fechar"}
              width={"60%"}
              executar={() => {
                setVisibleModalServiceGM(false);
              }}
            />
          </div>
        </div>
      </ModalC>
    </div>
  );
}
